import './styles/inspinia/_app.scss'

import { lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { LoadingLayout, PageLayoutNotFound } from '@ztechapps/webui.page'
import { AppContextProvider } from './hooks/useAppContext'
import { setupApolloClient } from './config/graphql'
import { routesDef } from './config/routes'
import { VerticalLayout } from './components/layout/VerticalLayout'

const OverviewPage = lazy(() => import('./view/overview'))
const TicketListPage = lazy(() => import('./view/tickets/list'))
const TicketDetailPage = lazy(() => import('./view/tickets/item'))
const ManifestPage = lazy(() => import('./view/tickets/manifest'))
const DriverListPage = lazy(() => import('./view/drivers/list'))
const DriverDetailPage = lazy(() => import('./view/drivers/item'))
const RouteListPage = lazy(() => import('./view/routes/list'))
const RouteDetailPage = lazy(() => import('./view/routes/item'))
const CustomerListPage = lazy(() => import('./view/customers/list'))
const CustomerDetailPage = lazy(() => import('./view/customers/item'))
const SettingsPage = lazy(() => import('./view/settings'))
const JoinPage = lazy(() => import('./view/account/join'))
const LoginPage = lazy(() => import('./view/account/login'))
const LoginSuccessPage = lazy(() => import('./view/account/login-success'))
const LoginFailedPage = lazy(() => import('./view/account/login-failed'))
const LoadingPage = lazy(() => import('./view/account/loading'))
const ChangePasswordPage = lazy(() => import('./view/account/change-password'))

const apolloClient = setupApolloClient()

export const App = () => {
  return (
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <AppContextProvider>
          <Routes>
            <Route
              index
              element={
                <LoadingLayout>
                  <LoadingPage />
                </LoadingLayout>
              }
            />
            <Route
              path={routesDef.JoinPage.path}
              element={
                <LoadingLayout>
                  <JoinPage />
                </LoadingLayout>
              }
            />
            <Route
              path={routesDef.LoginPage.path}
              element={
                <LoadingLayout>
                  <LoginPage />
                </LoadingLayout>
              }
            />
            <Route
              path={routesDef.AuthSuccessPage.path}
              element={
                <LoadingLayout>
                  <LoginSuccessPage />
                </LoadingLayout>
              }
            />
            <Route
              path={routesDef.AuthFailedPage.path}
              element={
                <LoadingLayout>
                  <LoginFailedPage />
                </LoadingLayout>
              }
            />
            <Route
              path={routesDef.ChangePasswordPage.path}
              element={
                <LoadingLayout>
                  <ChangePasswordPage />
                </LoadingLayout>
              }
            />

            <Route path="/app" element={<VerticalLayout />}>
              <Route path={routesDef.OverviewPage.path} element={<OverviewPage />} />
              <Route path={routesDef.TicketListPage.path} element={<TicketListPage />}>
                <Route path=":_id" element={<LoadingLayout><TicketDetailPage /></LoadingLayout>} />
              </Route>
              <Route path={routesDef.TicketDetailPage.path} element={<TicketDetailPage />} />
              <Route path={routesDef.TicketManifestPage.path} element={<ManifestPage />} />
              <Route path={routesDef.DriverListPage.path} element={<DriverListPage />}>
                <Route path=":_id" element={<LoadingLayout><DriverDetailPage /></LoadingLayout>} />
              </Route>
              <Route path={routesDef.DriverDetailPage.path} element={<DriverDetailPage />} />
              <Route path={routesDef.RouteListPage.path} element={<RouteListPage />}>
                <Route path=":_id" element={<LoadingLayout><RouteDetailPage /></LoadingLayout>} />
              </Route>
              <Route path={routesDef.RouteDetailPage.path} element={<RouteDetailPage />} />
              <Route path={routesDef.CustomerListPage.path} element={<CustomerListPage />}>
                <Route path=":_id" element={<LoadingLayout><CustomerDetailPage /></LoadingLayout>} />
              </Route>
              <Route path={routesDef.CustomerDetailPage.path} element={<CustomerDetailPage />} />
              <Route path={routesDef.SettingsPage.path} element={<SettingsPage />} />
              <Route path="*" element={<PageLayoutNotFound />} />
            </Route>

            <Route path="*" element={<PageLayoutNotFound />} />
          </Routes>
        </AppContextProvider>
      </ApolloProvider>
    </BrowserRouter>
  )
}
